import apiService from "./api";
import { LoginCredentials, AuthResponse, User } from "../types/auth";
import securityConfig from "../config/security";

export class AuthService {
  async login(credentials: LoginCredentials): Promise<AuthResponse> {
    const response = await apiService.post<{ data: AuthResponse }>(
      "/auth/login",
      credentials,
    );
    return response.data;
  }

  async verifyToken(): Promise<boolean> {
    try {
      // First try to get role from JWT token to determine correct endpoint
      const token = localStorage.getItem(securityConfig.TOKEN_STORAGE_KEY);
      let userRole: string | undefined;

      if (token) {
        try {
          const payload = JSON.parse(atob(token.split(".")[1]));
          userRole = payload?.role || payload?.userType;
        } catch (e) {
          // Continue with default profile endpoint if JWT decode fails
        }
      }

      // Use appropriate endpoint based on user role
      const endpoint = userRole === "dealer" ? "/dealer/profile" : "/profile";
      await apiService.get(endpoint);
      return true;
    } catch (error) {
      return false;
    }
  }

  async getProfile(): Promise<User> {
    // First try to get role from JWT token to determine correct endpoint
    const token = localStorage.getItem(securityConfig.TOKEN_STORAGE_KEY);
    let userRole: string | undefined;

    if (token) {
      try {
        const payload = JSON.parse(atob(token.split(".")[1]));
        userRole = payload?.role || payload?.userType;
      } catch (e) {
        // Continue with default profile endpoint if JWT decode fails
      }
    } else {
    }

    // Use appropriate endpoint based on user role
    const endpoint = userRole === "dealer" ? "/dealer/profile" : "/profile";
    const response = await apiService.get<any>(endpoint);

    // apiService.get() already unwraps TransformInterceptor's { data: ... } wrapper
    // So response is already the dealer profile object directly
    // Support both { user: ... } wrapper and direct profile object
    const user: User | undefined = response?.user || response;

    if (!user || (!user.email && !user.vatId)) {
      // Fallback: try to extract from nested structure if needed
      if (response && typeof response === "object") {
        if (
          response?.data &&
          typeof response.data === "object" &&
          (response.data.email || response.data.vatId)
        ) {
          return response.data as User;
        }
      }
      throw new Error("Invalid user profile response");
    }

    return user as User;
  }

  async logout(): Promise<void> {
    await apiService.post("/auth/logout");
  }
}

export const authService = new AuthService();
export default authService;
